export const MESSAGE_TYPES = {
  CONNECTION_ESTABLISHED: 'connection_established',
  AUTH_ERROR: 'auth_error',
  AI_RESPONSE: 'ai_response',
  TEXT_CHUNK: 'text_chunk',
  MESSAGE_COMPLETE: 'message_complete',
  TOOL_CALL: 'tool_call',
  SEGMENT_DATA: 'segment_data',
  SUGGESTION_CHIPS: 'suggestion_chips',
  PICKER: 'picker',
  CALLOUT: 'callout',
  ERROR: 'error',
} as const
